import { render, staticRenderFns } from "./CmajStat.vue?vue&type=template&id=39423aa7&"
import script from "./CmajStat.vue?vue&type=script&lang=js&"
export * from "./CmajStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports